
import { defineComponent, PropType } from 'vue'
import { Theme, ThemeSwitcher } from '@/modules/ThemeSwitcher'
import CalculatorButton from '@/components/CalculatorButton.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faEraser, faMoon, faSun } from '@fortawesome/free-solid-svg-icons'
import { IconDefinition } from '@fortawesome/free-regular-svg-icons'
import { faGithub } from '@fortawesome/free-brands-svg-icons'

export default defineComponent({
  components: {
    FontAwesomeIcon,
    CalculatorButton
  },
  props: {
    themeSwitcher: {
      required: true,
      type: Object as PropType<ThemeSwitcher>
    }
  },
  computed: {
    themes () {
      return Theme
    },
    faGithub () {
      return faGithub
    }
  },
  methods: {
    iconFor (theme: Theme): IconDefinition {
      switch (theme) {
        case Theme.light:
          return faSun
        case Theme.dark:
          return faMoon
        case Theme.nata:
          return faEraser
      }
    }
  },
  created () {
    this.themeSwitcher.loadUserTheme()
  }
})
